import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const CheckIcon = (props: SvgIconProps) => (
  <CheckOutlinedIcon {...props} fontSize="small" />
);

export default CheckIcon;
